import axios from 'axios'
import qs from 'qs'

// import store from '@/store'
import { Toast,Dialog } from 'vant'
// 根据环境不同引入不同api地址
import { baseApi } from '@/config'
import store from '@/store'
import { getToken, getUserInfo } from './storage'
// create an axios instance
const service = axios.create({
  baseURL: baseApi, // url = base api url + request url
  withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
})

let message = false
// request拦截器 request interceptor
service.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data,{indices:false})
    }
    // 不传递默认开启loading
    if (!config.hideloading) {
      // loading
      Toast.loading({
        forbidClick: true
      })
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    Toast.clear()
    const res = response.data
    if (res.status == 0) {
      message = false
      return Promise.resolve(res)
    } else if (res.status == 2) {// 登录超时,重新登录
    } else if (res.status == 6 || res.status == 7) {
      return Promise.reject(res)
    } else {
      message = false
      Dialog.alert({ message: res.error.msg }).then(() => {
      })
      return Promise.reject(res || 'error')
    }
  },
  error => {
    Toast.clear()
    console.log('err' + error) // for debug
    Dialog.alert({ message: '请求失败' }).then(() => {
    })
    return Promise.reject(error)
  }
)

export default service
